import React from 'react';
import { useCart } from './CartContext';
import './App.css';

function AddToCartNotification() {
  const { notification, clearNotification } = useCart();

  if (!notification) {
    return null;
  }

  return (
    <div className="add-to-cart-notification">
      <div className="notification-content">
        <div className="notification-icon">✓</div>
        <div className="notification-text">
          <strong>{notification.title}</strong>
          <span>Added to cart!</span>
        </div>
        <button
          className="notification-close"
          onClick={clearNotification}
          aria-label="Close notification"
        >
          ×
        </button>
      </div>
    </div>
  );
}

export default AddToCartNotification;
